import React from 'react';
import InputGroup from '../../InputGroup';

import { Field } from 'redux-form';

import { copyFor } from '../../../copy/copy';

const PostalCodeInput = props => (
    <Field
        name="postalCodeInput"
        component={InputGroup}
        type="text"
        label={copyFor('formFields', 'postalCode')}
        placeholder={copyFor('placeholders', 'postalCode')}
        autocomplete="off"
        inputColor="#000"
        maxLength={20}
    />
);

PostalCodeInput.propTypes = {};

export default PostalCodeInput;



// WEBPACK FOOTER //
// ./src/components/LocalRep/Form/PostalCodeInput.jsx